import { useQuery } from '@tanstack/react-query';
import { SearchDocumentRequest } from '../types/Document';
import { DOCUMENTS_SEARCH_KEY } from 'src/utils/constants/queryKeys';
import { getDocumentsFromSearchApi } from '../services/search-api/Documents';

export const useGetDocumentsFromSearchApi = (params: SearchDocumentRequest) => {
  return useQuery({
    queryKey: [DOCUMENTS_SEARCH_KEY, ...Object.values(params)],
    queryFn: () => getDocumentsFromSearchApi(params),
    enabled: !!params,
  });
};
